module.exports = __webpack_public_path__ + "static/michael-1faf92653774ed9bbc32ee7d60e50117.png";